import React, { useContext, useEffect, useState } from 'react';
import { useImmerReducer } from 'use-immer';
import { Link as RouterLink, Redirect } from 'react-router-dom';
import { useParams } from 'react-router';
import axiosConfig from '../../../utils/axiosConfig';
import Cookies from 'js-cookie';
import useStyles from './ResetPasswordStyles';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';

import Alert from '@material-ui/lab/Alert';
import Image from 'material-ui-image';

import {
    Box, Button, Checkbox, CssBaseline, CircularProgress,
    FormControlLabel, Grid, Link, Paper, MuiTextField, Typography
} from '@material-ui/core';

/* Context */
import { GlobalProvider, StateContext, DispatchContext } from '../../../context/Provider';

const ResetPassword = (props) => {

    const classes = useStyles();
    const { token } = useParams();
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState } = appState;
    const { authDispatch, globalDispatch } = appDispatch;

    const [user, setUser ] = useState({
        password: '',
        confirm_password: ''
    });

    const [isLoading, setIsLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);

    async function validateResetPasswordLink() {
        const res = await axiosConfig.get(`/resetPassword/${token}`);
        const { data } = res.data;

        if (res.data.status_code !== 'ok') {
            props.history.push('/login');
        }
    }

    async function resetPassword(values, resetForm) {
        const res = await axiosConfig.post(`/resetPassword`, {
            token: token,
            password: values.password,
            confirm_password: values.confirm_password
        });

        if (res.data.status_code === 'ok') {
            setSuccessMsg(res.data.message);
            setErrorMsg(null);

            setTimeout(() => {
                props.history.push('/login');
            }, 2400);

        } else {
            setErrorMsg(res.data.message);
            setSuccessMsg(null);
        }

        console.log(res);
        setIsLoading(false);
    }

    useEffect(() => {
        
        globalDispatch({type: 'setShowTabs', value: false});

        const source = axiosConfig.CancelToken.source();
        validateResetPasswordLink();
        return () => {
            source.cancel();
        }

    }, []);

    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <Box mb={2}>
                        <Image
                            src="/images/ap_epi_logo-resized.png"
                            imageStyle={{
                                width: '',
                                height: '80px',
                                position: 'relative'
                            }}
                            style={{paddingTop: '0'}}
                        />
                    </Box>

                    { successMsg ?
                        <Alert variant="filled" severity="success" style={{width: '100%'}}>
                            { successMsg }
                        </Alert>
                        : ''
                    }

                    { errorMsg ?
                        <Alert variant="filled" severity="error" style={{width: '100%'}}>
                            { errorMsg }
                        </Alert>
                        : ''
                    }

                    { !successMsg ? (
                        <Formik
                            initialValues={user}
                            validate={(values) => {
                                const errors = {};

                                if (!values.password) {
                                    errors.password = 'This field is required';
                                }

                                if (!values.confirm_password) {
                                    errors.confirm_password = 'This field is required';
                                }

                                if (values.password.length < 6) {
                                    errors.password = 'Password must be at least 6 characters.';
                                }

                                if (values.password !== values.confirm_password) {
                                    errors.confirm_password = 'Password does not match';
                                }

                                return errors;
                            }}
                            onSubmit={(values, {setSubmitting, resetForm}) => {
                                setSubmitting(false);
                                setIsLoading(true);
                                setSuccessMsg(null);
                                setErrorMsg(null);
                                resetPassword(values, resetForm);
                            }}
                        >
                            {({submitForm, isSubmitting, touched, errors}) => (
                                
                                <Form className={classes.form}>

                                    <Typography variant="subtitle1" style={{fontSize: "20px"}}>
                                        Change Password
                                    </Typography>
                                    
                                    <Field
                                        component={TextField}
                                        label="New Password"
                                        name="password"
                                        type="password"
                                        fullWidth
                                        variant="outlined"
                                        margin="normal"
                                        autoComplete="off"
                                    />

                                    <Field
                                        component={TextField}
                                        label="Confirm New Password"
                                        name="confirm_password"
                                        type="password"
                                        fullWidth
                                        variant="outlined"
                                        margin="normal"
                                        autoComplete="off"
                                    />

                                    <Button 
                                        disabled={isSubmitting}
                                        fullWidth
                                        color="primary"
                                        variant="contained"
                                        disableElevation
                                        className={classes.submit}
                                        onClick={submitForm}
                                    >
                                        { isLoading 
                                            ? (<CircularProgress size={24} className={classes.buttonProgress} />) 
                                            : 'RESET PASSWORD'
                                        }
                                    </Button>

                                    {/* <Link
                                        component={RouterLink}
                                        variant="body2"
                                        underline="always"
                                        to="/login"
                                    >
                                        Back to login page
                                    </Link> */}
                                </Form>
                            )}
                        </Formik>
                    ) : (
                        <Box mt={2}>
                            <Link
                                component={RouterLink}
                                variant="body2"
                                underline="always"
                                to="/login"
                            >
                                Back to login page
                            </Link>
                        </Box>
                    )}

                </div>  
            </Grid>
        </Grid>
    );
}

export default ResetPassword;